<template>
  <aside class="row subtle sm-flex align-items-center">
    <figure class="c4 pr2 py2 c2-mb right-mb">
      <a href="https://louderthanten.com/apprenticeship"><svg-circles/></a>
    </figure>
    <div class="c2">
      <h2 class="display font-size-5 mb2"><a
        href="https://louderthanten.com/apprenticeship"
        class="underline-4-accent">Not everyone can
        slay&nbsp;estimates.<br >
        But our apprentices&nbsp;can.</a></h2>
      <p>The Louder Than Ten apprenticeship for people who manage&nbsp;projects</p>
      <p class="font-size-2 measure">Your company needs adaptable project leads who clear the chaos to save you time, money, and hours of therapy. We&nbsp;train&nbsp;them.</p>
      <p class="pt1"><a
        href="https://louderthanten.com/apprenticeship"
        class="button accent-button">Learn more about the program</a></p>
    </div>
  </aside>
</template>

<script>
import Circles from '../svgs/Circles'

export default {
  components: {
    svgCircles: Circles
  }
}
</script>

<style scoped>
  figure {
    max-width: 350px;
  }
</style>
